import { OrderModelType } from '@easy-lib/constants';
import { DraftOrder, IBaseOrderEntity, OMSOrder, OfflineOrder } from '@easy-lib/modules/order/oms';
import { OmsState } from '@easy-lib/state/app.state';
import { EntityAdapter, EntityState, Update } from '@ngrx/entity';

export function updateOrdersState(state: OmsState, ids: string[], props: Partial<IBaseOrderEntity>) {
	const orders = Object.values(state.entities).filter(t => ids?.includes(t.id));
	const updatedData = orders.map(order => ({ ...order, ...props }));
	return updatedData;
}
export const instance: { [key in OrderModelType]: (order) => IBaseOrderEntity } = {
	[OrderModelType.draft]: order => new DraftOrder(order),
	[OrderModelType.oms]: order => new OMSOrder(order),
	[OrderModelType.offline]: order => new OfflineOrder(order),
	[OrderModelType.algorithm]: () => null
};
export function getOrderInstance(order: IBaseOrderEntity): IBaseOrderEntity {
	return instance[order.orderModelType](order);
}
export function getOrderInstances(orders: IBaseOrderEntity[]) {
	return orders.map(order => getOrderInstance(order));
}
//HesamTodo: must be review later
export function updateState(
	adapter: EntityAdapter<IBaseOrderEntity>,
	value: Update<IBaseOrderEntity>,
	state: EntityState<IBaseOrderEntity>
): EntityState<IBaseOrderEntity> {
	if (!state.entities) return state;
	const order = Object.values(state.entities).find(t => t.id === value.id);
	if (!order) return state;
	const newState = adapter.removeOne(value.id as string, state);
	return adapter.addOne(getOrderInstance({ ...order, ...value.changes }), newState);
}
